import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import SEXOS from "../../data/Sexos";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Select from "../../components/form/Select";
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import {FormDataToJson} from '../../utils/json/Json';
import PAGES from '../../config/Pages';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import moment from 'moment';

import ButtonTipoTreino from '../planilha-treino/ButtonTipoTreino';
import FormSexo from './FormSexo';

const URL_SAVE = WS.domiciliar.save;
const DEFAULT = {
	id: "",
	nome: "",
	data_inicial: "",
	data_final: "",
	masculino: {
		observacoes: "",
		circuito: "",
		repeticoes: "",
		sessoes: "",
		cadencia: "",
		exercicios: []
	},
	feminino: {
		cadencia: "",
		observacoes: "",
		circuito: "",
		repeticoes: "",
		sessoes: "",
		exercicios: []
	}
};

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeSexo = this.changeSexo.bind(this);
    this.state = {
      sexoAtivo:SEXOS[0].value,
      sexos:SEXOS,
      wrapper: Random(7),
      strings: STRINGS[window.LANGUAGE],
      detalhe: props.detalhe ? props.detalhe : DEFAULT,
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  changeSexo(e) {
    let id = e.currentTarget.getAttribute("data-id");
    this.setState({sexoAtivo: id});
    e.preventDefault();
  }

  handleSubmit (e){
    e.preventDefault();
    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar,
      erroDataPlanilha
    }
    = this.state.strings;

    //objeto que conterá todos os blocos de planilha
    let obj = DEFAULT;
    const form = e.target;

    for (let i= 0; i< SEXOS.length ; i++ ){
      const identifier = SEXOS[i].identifier;
      const wrapperTipo = form.querySelectorAll("[data-id='"+identifier+"']")[0];

      const circuito = wrapperTipo.querySelectorAll("[name='circuito']")[0].value;
      const repeticoes = wrapperTipo.querySelectorAll("[name='repeticoes']")[0].value;
      const sessoes = wrapperTipo.querySelectorAll("[name='sessoes']")[0].value;
			const cadencia = wrapperTipo.querySelectorAll("[name='cadencia']")[0].value;
      const observacoes = wrapperTipo.querySelectorAll("[name='observacoes']")[0].value;

      let elements = wrapperTipo.querySelectorAll('.item-listagem');
      const exercicios = [];
      elements.forEach((value, key)=>{
        let idEl = value.getAttribute('data-id');
        if(idEl){
          exercicios.push(idEl);
        }
      });
      const data = {
				cadencia,
        circuito,
        repeticoes,
        sessoes,
        observacoes,
        exercicios
      };
      obj[identifier] = data;
    }

    const nome = form.querySelectorAll("[name='nome']")[0].value;
    const dti = form.querySelectorAll("[name='dti']")[0].value;
    const dtf = form.querySelectorAll("[name='dtf']")[0].value;
    const id = form.querySelectorAll("[name='id']")[0].value;

    obj.nome = nome;
    obj.data_inicial = dti;
    obj.data_final = dtf;

    if(id){
      obj.id = id;
    }

    if(!nome){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);
      return false;
    }

    //checa a data para verificar se o dia inicial e final tem 6 dias
    const dayArr = dtf.split('/');
    const dayFormated = dayArr[2]+'-'+dayArr[1]+"-"+dayArr[0];
    const new_date = moment(dtf, "DD/MM/YYYY").subtract(6, 'days');
    const day = new_date.format('DD');
    const month = new_date.format('MM');
    const year = new_date.format('YYYY');
    const diaCheck = day + '/' + month + '/' + year;

    if(dti !== diaCheck){
      let msg = {
        title: atencao,
        text: erroDataPlanilha
      };
      Dialog.create(msg);
      return false;
    }

    const history = this.props.history;

    Requisitions({
      url: URL_SAVE,
      data: obj,
      sucess:function(data){
        var msg;
        _self.props.modal.close();
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
        history.push(PAGES.exerciciosDomiciliares);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });

    /*//retorna todos os exercicios adicionados
    let idForm = e.target.getAttribute('id');
    let elements = document.getElementById(idForm).querySelectorAll('.item-listagem');
    var exercicios = [];

    //transforma o formData em um json
    var object = FormDataToJson(formData);

    if(!object.nome){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);
      return false;
    }

    //é obrigatório adicionar exercícios
    if(elements.length<=0){
      let msg = {
        title: atencao,
        text:escolhaOsExercicios
      };
      Dialog.create(msg);
      return false;
    }

    elements.forEach((value, key)=>{
      let idEl = value.getAttribute('data-id');
      if(idEl){
        exercicios.push(idEl);
      }
    });

    object.exercicios = exercicios;

    //----------------

    const history = this.props.history;
    object.data_inicial = object.dti;
    object.data_final= object.dtf;

    //checa a data para verificar se o dia inicial e final tem 6 dias
    const dayArr = object.dtf.split('/');
    const dayFormated = dayArr[2]+'-'+dayArr[1]+"-"+dayArr[0];
    const new_date = moment(object.dtf, "DD/MM/YYYY").subtract(5, 'days');
    const day = new_date.format('DD');
    const month = new_date.format('MM');
    const year = new_date.format('YYYY');
    const diaCheck = day + '/' + month + '/' + year;

    if(object.dti !== diaCheck){
      let msg = {
        title: atencao,
        text: erroDataPlanilha
      };
      Dialog.create(msg);
      return false;
    }

    Requisitions({
      url:URL_SAVE,
      data: object,
      sucess:function(data){
        var msg;
        _self.props.modal.close();
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
        history.push(PAGES.exerciciosDomiciliares);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });*/
  }

  render (){
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} /> : '';
    const {
      dataInicio,
      dataFim,
      treinoDomiciliar,
      nomeTreinoDomiciliar,
      observacoes,
      salvar,
      digiteAqui,
      sexo,
      circuito,
      repeticoes,
      sessoes
    } = this.state.strings;
    const valNomeBloco = this.props.detalhe ? this.props.detalhe.nome : '';
    const sexoBloco = this.props.detalhe ? (this.props.detalhe.sexo === 'm' ? SEXOS[0] : SEXOS[1]): '';
    const observacoesBloco = this.props.detalhe ? this.props.detalhe.observacoes : '';

    const dti = this.props.detalhe ? this.props.detalhe.data_inicial : null;
    const dtf = this.props.detalhe ? this.props.detalhe.data_final : null;

    const sexos = this.state.sexos;
    const sexoAtivo = this.state.sexoAtivo;

    const buttonsSexos = sexos.map((tipoTreino,i)=>{
      let ativo = tipoTreino.value === sexoAtivo;

        return (
          <ButtonTipoTreino
            key={i.toString()}
            id={tipoTreino.value}
            onClick={this.changeSexo}
            label={tipoTreino.label}
            ativo={ativo}>
          </ButtonTipoTreino>
        )
      }
    );//end map

    const listSexos = sexos.map((tipoTreino,i)=>{
        let ativo = tipoTreino.value === sexoAtivo;
        const data = this.state.detalhe[tipoTreino.identifier] ? this.state.detalhe[tipoTreino.identifier] : [];

        return (
          <FormSexo
						sexo={sexoAtivo}
            data={data}
            identifier={tipoTreino.identifier}
            id={Random(7)}
            key={i.toString()}
            ativo={ativo} />
        )
      }
    );//end map

    return (
      <div className='box-cadastro-bloco'>
        <MainTitle title={treinoDomiciliar}></MainTitle>
        <form id={this.state.wrapper} onSubmit={this.handleSubmit}>
            {id}
          <div className="pure-u-15-24">
            <TextInput name="nome" title={nomeTreinoDomiciliar+"*"} placeholder={digiteAqui} value={valNomeBloco} />
          </div>
          <div className="pure-u-9-24">
            <DateRangePickerWrapper
               dti={dti}
               dtf={dtf}
               titleDateInicio={dataInicio}
               titleDateFim={dataFim} />
          </div>
          <div>
            <div className="pure-u-9-24 box-tipos-planilha">
              <div className="box-input--title">Sexo</div>
              {buttonsSexos}
            </div>
          </div>
          <div>
            {listSexos}
          </div>
          <br />
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/treino-domiciliar/Page.js